// extracted by mini-css-extract-plugin
module.exports = {"markdown":"style-module_markdown__hK93Ihpzys1Np7SRLfuE","secondaryText":"style-module_secondaryText__PGuNgkaM4QiCecdNPxam"};